<template>
  <div class="styleCard">
    <ul class="style-nav style2">
      <li
        v-for="tab in sysTabs"
        :key="tab.id"
        :class="{ active: selectedTab === tab.alias }"
        @click="selectedTab = tab.alias"
      >
        {{ tab.name }}
      </li>
    </ul>
    <div v-if="selectedTab === 'SYSTEM_LOG'">
      <span class="takeItRightRef"
        ><button @click="getAllInfo('f')"><i class="fas fa-sync"></i></button
      ></span>
      <span class="takeItRight">
        <button @click="prevPage('f')">Prev</button>
        <button @click="nextPage('f')">Next</button>
      </span>
      <h2 class="text-center">System-Log</h2>

      <table class="table table-flex ">
        <thead>
          <tr>
            <th class="pb">user</th>
            <th>
              asset
              <button
                @click="applyAlphaSorting('f')"
                class="btn btn-default btn-sm override sorting-btn"
              >
                <span
                  class="fas fa-sort-alpha-down"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
                    'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">status</th>
            <th>
              <span>
                created<button
                  @click="applyNumericSorting('f')"
                  class="btn sorting-btn"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',
                      'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'
                    }"
                  ></span>
                </button>
              </span>
            </th>
            <th class="pb">updated</th>
            <th class="pb">Page{{ tFirstPage }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(temp, idx) in sysLog" :key="idx">
            <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>
            <td>{{ temp.asset }}</td>
            <td style="font-size: 10px">{{ temp.status | truncate(200) }}</td>
            <td class="temp">{{ temp.created_at }}</td>
            <td class="temp">{{ temp.updated_at }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="selectedTab === 'CLIENT_CRONE_LOG'">
      <span class="takeItRightRef"
        ><button @click="getAllInfo('s')"><i class="fas fa-sync"></i></button
      ></span>

      <span class="takeItRightS">
        <button @click="prevPage('s')">Prev</button>
        <button @click="nextPage('s')">Next</button>
      </span>
      <h2 class="text-center">Client-Cron-Log</h2>
      <table class="table table-flex">
        <thead>
          <tr>
            <th :class="{ pb: clientLog[0].client_id === null }">
              client
              <button
                v-if="clientLog[0].client_id !== null"
                @click="applyNumericClientSorting('s')"
                class="btn btn_sort3"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down':
                      sortOrderClientNumeric === 'asc',
                    'fas fa-sort-numeric-up': sortOrderClientNumeric === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">user</th>
            <!--        <td>process_id</td>-->
            <th>
              asset
              <button
                @click="applyAlphaSorting('s')"
                class="btn btn-default btn-sm override sorting-btn"
              >
                <span
                  class="fas fa-sort-alpha-down"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
                    'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">status</th>
            <th>
              created
              <button @click="applyNumericSorting('s')" class="btn secSort">
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',
                    'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">updated</th>
            <th class="pb">Page{{ tSecPage }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(temp, idx) in clientLog" :key="idx">
            <td>{{ temp.client_id != null ? temp.client_id : "" }}</td>
            <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>
            <!--        <td>{{temp.process_id}}</td>-->
            <td>{{ temp.asset }}</td>
            <td style="font-size: 10px">{{ temp.status | truncate(200) }}</td>
            <td class="temp">{{ temp.created_at }}</td>
            <td class="temp">{{ temp.updated_at }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="selectedTab === 'TASK_CRONE_LOG'">
      <span class="takeItRightRef"
        ><button @click="getAllInfo('t')"><i class="fas fa-sync"></i></button
      ></span>

      <span class="takeItRightT">
        <button @click="prevPage('t')">Prev</button>
        <button @click="nextPage('t')">Next</button>
      </span>
      <h2 class="text-center">Task-Cron-Log</h2>
      <table class="table table-flex thirdTable">
        <thead>
          <tr>
            <th>
              client
              <button
                @click="applyNumericClientSorting('t')"
                class="btn btn_sort3"
              >
                <span
                  class="fa"
                  :class="{
                    'fas fa-sort-numeric-down':
                      sortOrderClientNumeric === 'asc',
                    'fas fa-sort-numeric-up': sortOrderClientNumeric === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">task</th>
            <th class="pb">user</th>
            <!--        <th>process</th>-->
            <!--        <th>batch_count</th>-->
            <th>
              asset
              <button
                @click="applyAlphaSorting('t')"
                class="btn btn-default btn-sm override sorting-btn"
              >
                <span
                  class="fas fa-sort-alpha-down"
                  :class="{
                    'fas fa-sort-alpha-down': sortOrderAlpha === 'asc',
                    'fas fa-sort-alpha-up': sortOrderAlpha === 'desc'
                  }"
                ></span>
              </button>
            </th>
            <th class="pb">status</th>
            <th>
              <span
                >created
                <button @click="applyNumericSorting('t')" class="btn btn_sort3">
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',
                      'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'
                    }"
                  ></span></button
              ></span>
            </th>
            <th class="pb">updated</th>
            <th class="pb">Page{{ tThreePage }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(temp, idx) in taskLog" :key="idx">
            <td>{{ temp.client_id != null ? temp.client_id : "" }}</td>
            <td>{{ temp.task_id != null ? temp.task_id : "" }}</td>
            <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>
            <!--        <th>{{temp.process_id}}</th>-->
            <!--        <th>{{temp.batch_count}}</th>-->
            <td>{{ temp.asset }}</td>
            <td class="third" style="font-size: 10px">
              {{
                temp.status != null
                  ? temp.status.length > 200
                    ? temp.status.substr(0, 200)
                    : "NO-STAT"
                  : "NO-STAT"
              }}
            </td>
            <td class="temp third">{{ temp.created_at }}</td>
            <td class="temp third">{{ temp.updated_at }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!--  <div class="root">-->
  <!--    <span class="takeItRightRef"><button @click="getAllInfo">RefreshIt</button></span>-->

  <!--    <span class="takeItRight">-->
  <!--      <button @click="prevPage('f')">Prev</button>-->
  <!--      <button @click="nextPage('f')">Next</button>-->
  <!--    </span>-->
  <!--    <h2 class="text-center">System-Log</h2>-->

  <!--    <table class="table table-flex ">-->
  <!--      <thead>-->
  <!--        <tr>-->
  <!--          <th>user</th>-->
  <!--          <th>asset</th>-->
  <!--          <th>status</th>-->
  <!--          <th><span>-->
  <!--            created<button @click="applyNumericSorting('f')" class="btn sorting-btn">-->
  <!--              <span-->
  <!--                class="fa"-->
  <!--                :class="{-->
  <!--                  'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',-->
  <!--                  'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'-->
  <!--                }"-->
  <!--              ></span>-->
  <!--            </button>-->
  <!--            </span>-->
  <!--          </th>-->
  <!--          <th>updated</th>-->
  <!--          <th>Page{{ tFirstPage }}</th>-->
  <!--        </tr>-->
  <!--      </thead>-->
  <!--      <tbody>-->
  <!--        <tr v-for="(temp, idx) in sysLog" :key="idx">-->
  <!--          <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>-->
  <!--          <td>{{ temp.asset }}</td>-->
  <!--          <td style="font-size: 10px">{{ temp.status | truncate(200) }}</td>-->
  <!--          <td class="temp">{{ temp.created_at }}</td>-->
  <!--          <td class="temp">{{ temp.updated_at }}</td>-->
  <!--          <td></td>-->
  <!--        </tr>-->
  <!--      </tbody>-->
  <!--    </table>-->

  <!--    <span class="takeItRight">-->
  <!--      <button @click="prevPage('s')">Prev</button>-->
  <!--      <button @click="nextPage('s')">Next</button>-->
  <!--    </span>-->
  <!--    <h2 class="text-center">Client-Cron-Log</h2>-->
  <!--    <table class="table table-flex">-->
  <!--      <thead>-->
  <!--        <tr>-->
  <!--          <td>client</td>-->
  <!--          <td>user</td>-->
  <!--          &lt;!&ndash;        <td>process_id</td>&ndash;&gt;-->
  <!--          <td>asset</td>-->
  <!--          <td>status</td>-->
  <!--          <td>created-->
  <!--           <button @click="applyNumericSorting('s')" class="btn secSort">-->
  <!--              <span-->
  <!--                      class="fa"-->
  <!--                      :class="{-->
  <!--                  'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',-->
  <!--                  'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'-->
  <!--                }"-->
  <!--              ></span>-->
  <!--            </button>-->
  <!--            </td>-->
  <!--          <td>updated</td>-->
  <!--          <th>Page{{ tSecPage }}</th>-->
  <!--        </tr>-->
  <!--      </thead>-->
  <!--      <tbody>-->
  <!--        <tr v-for="(temp, idx) in clientLog" :key="idx">-->
  <!--          <td>{{ temp.client_id != null ? temp.client_id : "" }}</td>-->
  <!--          <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>-->
  <!--          &lt;!&ndash;        <td>{{temp.process_id}}</td>&ndash;&gt;-->
  <!--          <td>{{ temp.asset }}</td>-->
  <!--          <td style="font-size: 10px">{{ temp.status | truncate(200) }}</td>-->
  <!--          <td class="temp">{{ temp.created_at }}</td>-->
  <!--          <td class="temp">{{ temp.updated_at }}</td>-->
  <!--          <td></td>-->
  <!--        </tr>-->
  <!--      </tbody>-->
  <!--    </table>-->

  <!--    <span class="takeItRight">-->
  <!--      <button @click="prevPage('t')">Prev</button>-->
  <!--      <button @click="nextPage('t')">Next</button>-->
  <!--    </span>-->
  <!--    <h2 class="text-center">Task-Cron-Log</h2>-->
  <!--    <table class="table table-flex thirdTable">-->
  <!--      <thead>-->
  <!--        <tr>-->
  <!--          <th>client</th>-->
  <!--          <th>task</th>-->
  <!--          <th>user</th>-->
  <!--          &lt;!&ndash;        <th>process</th>&ndash;&gt;-->
  <!--          &lt;!&ndash;        <th>batch_count</th>&ndash;&gt;-->
  <!--          <th>asset</th>-->
  <!--          <th>status</th>-->
  <!--          <th> <span>created-->
  <!--            <button @click="applyNumericSorting('t')" class="btn btn_sort3">-->
  <!--              <span-->
  <!--                      class="fa"-->
  <!--                      :class="{-->
  <!--                  'fas fa-sort-numeric-down': sortOrderNumeric === 'asc',-->
  <!--                  'fas fa-sort-numeric-up': sortOrderNumeric === 'desc'-->
  <!--                }"-->
  <!--              ></span>-->
  <!--            </button></span></th>-->
  <!--          <th>updated</th>-->
  <!--          <th>Page{{ tThreePage }}</th>-->
  <!--        </tr>-->
  <!--      </thead>-->
  <!--      <tbody>-->
  <!--        <tr v-for="(temp, idx) in taskLog" :key="idx">-->
  <!--          <td>{{ temp.client_id != null ? temp.client_id : "" }}</td>-->
  <!--          <td>{{ temp.task_id != null ? temp.task_id : "" }}</td>-->
  <!--          <td>{{ temp.user_id !== null ? temp.user_id : "" }}</td>-->
  <!--          &lt;!&ndash;        <th>{{temp.process_id}}</th>&ndash;&gt;-->
  <!--          &lt;!&ndash;        <th>{{temp.batch_count}}</th>&ndash;&gt;-->
  <!--          <td>{{ temp.asset }}</td>-->
  <!--          <td style="font-size: 10px">-->
  <!--            {{-->
  <!--              temp.status != null-->
  <!--                ? temp.status.length > 200-->
  <!--                  ? temp.status.substr(0, 200)-->
  <!--                  : "NO-STAT"-->
  <!--                : "NO-STAT"-->
  <!--            }}-->
  <!--          </td>-->
  <!--          <td class="temp">{{ temp.created_at }}</td>-->
  <!--          <td class="temp"> {{ temp.updated_at }}</td>-->
  <!--          <td></td>-->
  <!--        </tr>-->
  <!--      </tbody>-->
  <!--    </table>-->
  <!--  </div>-->
</template>

<script>
import apiClientCreator from "../../../helpers/api/request";
import moment from "moment";

export default {
  name: "SystemLog",
  data() {
    return {
      sysLog: null,
      clientLog: null,
      taskLog: null,
      tFirstPage: null,
      tSecPage: null,
      tThreePage: null,
      sortOrderNumeric: "asc",
      sortOrderClientNumeric: "asc",
      selectedTab: "SYSTEM_LOG",
      sysTabs: [
        {
          id: 0,
          name: "System Log",
          alias: "SYSTEM_LOG"
        },
        {
          id: 1,
          name: "Client Cron Log",
          alias: "CLIENT_CRONE_LOG"
        },
        {
          id: 2,
          name: "Task Cron Log",
          alias: "TASK_CRONE_LOG"
        }
      ],
      sortOrderAlpha: "asc"
    };
  },
  created() {},
  mounted() {
    this.getAllInfo("all");
  },
  methods: {
    applyAlphaSorting(tableNum) {
      if (tableNum === "f") {
        if (this.sortOrderAlpha.toString() === "asc") {
          this.sortOrderAlpha = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tFirstPage = res.data[0].current_page;
              this.sysLog = res.data[0].data;
            });
        }

        // reverse sortOrder
        if (this.sortOrderAlpha.toString() === "desc") {
          this.sortOrderAlpha = "asc";

          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tFirstPage = res.data[0].current_page;
              this.sysLog = res.data[0].data;
            });
        }
      } else if (tableNum === "s") {
        if (this.sortOrderAlpha.toString() === "asc") {
          this.sortOrderAlpha = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tSecPage = res.data[0].current_page;
              this.clientLog = res.data[0].data;
            });
        }

        // reverse sortOrder
        if (this.sortOrderAlpha.toString() === "desc") {
          this.sortOrderAlpha = "asc";

          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tSecPage = res.data[0].current_page;
              this.clientLog = res.data[0].data;
            });
        }
      } else if (tableNum === "t") {
        if (this.sortOrderAlpha.toString() === "asc") {
          this.sortOrderAlpha = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }

        // reverse sortOrder
        if (this.sortOrderAlpha.toString() === "desc") {
          this.sortOrderAlpha = "asc";

          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderAlpha}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }
      }
    },

    applyNumericSorting(tableNum) {
      if (tableNum === "f") {
        if (this.sortOrderNumeric.toString() === "asc") {
          this.sortOrderNumeric = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tFirstPage = res.data[0].current_page;
              this.sysLog = res.data[0].data;
            });
        }
        if (this.sortOrderNumeric.toString() === "desc") {
          this.sortOrderNumeric = "asc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tFirstPage = res.data[0].current_page;
              this.sysLog = res.data[0].data;
            });
        }
      } else if (tableNum === "s") {
        if (this.sortOrderNumeric.toString() === "asc") {
          this.sortOrderNumeric = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("")
            .then(res => {
              this.tSecPage = res.data[0].current_page;
              this.clientLog = res.data[0].data;
            });
        }
        if (this.sortOrderNumeric.toString() === "desc") {
          this.sortOrderNumeric = "asc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tSecPage = res.data[0].current_page;
              this.clientLog = res.data[0].data;
            });
        }
      } else if (tableNum === "t") {
        if (this.sortOrderNumeric.toString() === "asc") {
          this.sortOrderNumeric = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("")
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }
        if (this.sortOrderNumeric.toString() === "desc") {
          this.sortOrderNumeric = "asc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderNumeric}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }
      }
    },
    applyNumericClientSorting(tableNum) {
      if (tableNum === "t") {
        if (this.sortOrderClientNumeric.toString() === "asc") {
          this.sortOrderClientNumeric = "desc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderClientNumeric}/${tableNum}`
          )
            .get("")
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }
        if (this.sortOrderClientNumeric.toString() === "desc") {
          this.sortOrderClientNumeric = "asc";
          return apiClientCreator(
            `admin/user/systemLog/${this.sortOrderClientNumeric}/${tableNum}`
          )
            .get("", {
              tableNum: tableNum
            })
            .then(res => {
              this.tThreePage = res.data[0].current_page;
              this.taskLog = res.data[0].data;
            });
        }
      }
    },

    nextPage(tableNum) {
      if (tableNum === "f") {
        this.tFirstPage += 1;
        apiClientCreator(`admin/user/systemLog?page=${this.tFirstPage}`)
          .get("")
          .then(res => {
            this.tFirstPage = res.data[0].current_page;
            // this.tSecPage = res.data[1].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.sysLog = res.data[0].data;
            // this.clientLog = res.data[1].data;
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "s") {
        this.tSecPage += 1;
        apiClientCreator(`admin/user/clientCronLog?page=${this.tSecPage}`)
          .get("")
          .then(res => {
            this.tSecPage = res.data[0].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.clientLog = res.data[0].data;
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "t") {
        this.tThreePage += 1;
        apiClientCreator(`admin/user/taskCronLog?page=${this.tThreePage}`)
          .get("")
          .then(res => {
            this.tThreePage = res.data[0].current_page;
            this.taskLog = res.data[0].data;
          });
      }
    },
    prevPage(tableNum) {
      if (tableNum === "f") {
        this.tFirstPage -= 1;
        apiClientCreator(`admin/user/systemLog?page=${this.tFirstPage}`)
          .get("")
          .then(res => {
            this.tFirstPage = res.data[0].current_page;
            // this.tSecPage = res.data[1].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.sysLog = res.data[0].data;
            // this.clientLog = res.data[1].data;
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "s") {
        this.tSecPage -= 1;
        apiClientCreator(`admin/user/clientCronLog?page=${this.tSecPage}`)
          .get("")
          .then(res => {
            this.tSecPage = res.data[0].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.clientLog = res.data[0].data;
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "t") {
        this.tThreePage -= 1;
        apiClientCreator(`admin/user/taskCronLog?page=${this.tThreePage}`)
          .get("")
          .then(res => {
            this.tThreePage = res.data[0].current_page;
            this.taskLog = res.data[0].data;
          });
      }
    },
    getAllInfo(tableNum) {
      if (tableNum === "all") {
        apiClientCreator(`admin/user/systemLog`)
          .get("")
          .then(res => {
            this.tFirstPage = res.data[0].current_page;
            // this.tSecPage = res.data[1].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.sysLog = res.data[0].data;
            // this.clientLog = res.data[1].data;
            // this.taskLog = res.data[2].data;
          });

        apiClientCreator(`admin/user/clientCronLog`)
          .get("")
          .then(res => {
            this.tSecPage = res.data[0].current_page;
            this.clientLog = res.data[0].data;
            // console.log(this.tFirstPage)
            // this.taskLog = res.data[2].data;
          });

        apiClientCreator(`admin/user/taskCronLog`)
          .get("")
          .then(res => {
            this.tThreePage = res.data[0].current_page;
            this.taskLog = res.data[0].data;
          });
      }

      if (tableNum === "f") {
        apiClientCreator(`admin/user/systemLog`)
          .get("")
          .then(res => {
            this.tFirstPage = res.data[0].current_page;
            // this.tSecPage = res.data[1].current_page;
            // this.tTheePage = res.data[2].current_page;
            this.sysLog = res.data[0].data;
            // this.clientLog = res.data[1].data;
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "s") {
        apiClientCreator(`admin/user/clientCronLog`)
          .get("")
          .then(res => {
            this.tSecPage = res.data[0].current_page;
            this.clientLog = res.data[0].data;
            // console.log(this.tFirstPage)
            // this.taskLog = res.data[2].data;
          });
      }
      if (tableNum === "t") {
        apiClientCreator(`admin/user/taskCronLog`)
          .get("")
          .then(res => {
            this.tThreePage = res.data[0].current_page;
            this.taskLog = res.data[0].data;
          });
      }
    }
  }
};
</script>

<style scoped>
.root {
  margin: 0 auto;
  height: auto;
  max-width: 83%;
  font-family: Montserrat !important;
  font-size: 12px;
}
.popup-content {
  padding: 10px;
  position: absolute;
  top: 84px;
  right: 110px;
  z-index: 10001;
  width: max-content;
  background-color: #fff;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
}
.text-center {
  text-align: left;
}
h3 {
  float: right;
}
.takeItRight {
  position: relative;
  left: 89%;
  top: 64px;
}
.takeItRightS {
  position: relative;
  left: 92%;
  top: 64px;
}
.takeItRightT {
  position: relative;
  left: 92%;
  top: 64px;
}
.takeItRightRef {
  position: relative;
  left: 97.5%;
  top: 34px;
}
.sorting-btn {
  cursor: pointer;
  /*  margin-left: 5px;*/
  width: 20px;
  height: 30px;
  padding: 5px 5px;
  /*  padding-right: 16px !important;*/
  /*//border-radius: 4px;*/
  /*  !*  border: 1px solid #dee2e6;*!*/
  /*  color: black;*/
  background: #fff;
  /*  margin-bottom: 5px;*/
  transition-duration: 0.4s;
  /*position: absolute;*/
  /*top: 123px;*/
  /*right: 349px;*/
  border: 1px solid white;
}
.secSort {
  cursor: pointer;
  width: 20px;
  height: 30px;
  padding: 5px 5px;
  background: #fff;
}
.btn_sort3 {
  cursor: pointer;
  width: 20px;
  height: 30px;
  padding: 5px 5px;
  background: #fff;
  /*position: absolute;*/
  /*top: 1690px;*/
  /*right: 341px;*/
}
.sorting-btn,
.secSort,
.btn_sort3:focus {
  /*background-color: #e0e0e0;*/
  outline: none;
}
td.temp {
  min-width: 153px;
  max-width: 155px;
  overflow: hidden;
}
.styleCard {
  font-size: 12px !important;
  -webkit-box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  box-shadow: 0px 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
  height: -webkit-max-content;
  height: -moz-max-content;
  height: max-content;
  min-width: 300px;
  width: 83%;
  position: absolute;
  margin: auto auto 10px auto;
  top: 50px;
  right: 0;
  left: 0;
}

.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
  /*
    background: white;
  */
}
.style-nav.style2 li {
  /*border-radius: 3px 3px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
table th,
.third {
  text-align: center;
}
.pb {
  vertical-align: middle !important;
}
</style>
